import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { GrInstagram } from "react-icons/gr";
import { FaPhoneAlt, FaEnvelope, FaWhatsapp, FaFacebookF, FaYoutube, FaMapMarkerAlt } from "react-icons/fa";
import useCatalogNavigation from "../hooks/useCatalogNavigation";
import card from "../images/cardimage.png";
const Footer = () => {
  const { categories } = useCatalogNavigation();

  return (
    <>
        <footer className="pt-5 pb-3">
            <Container className="p-lg-0">
                <Row className='mx-0 mb-2'>
                    <Col lg={12} className="mb-4">
                        <ul className="footer-list">
                            
                            <li>
                                <h6>Shop by Category</h6>
                                <div className="footer-category-links">
                                    {categories.map((category) => (
                                        <Link
                                            key={category.category_id}
                                            to={`/shop?category_id=${encodeURIComponent(category.category_id)}`}
                                        >
                                            {category.name}
                                        </Link>
                                    ))}
                                </div>
                            </li>
                            <li>
                                <h6>Customer Service</h6>
                                <Link to="/">Home</Link>
                                <Link to="/shop">Our Shop</Link>
                                <Link to="/contact-us">Get in touch</Link>
                                <Link to="/about-us">About Us</Link>
                            </li>
                             <li>
                                <h6>Legal Policies</h6>
                                <Link to="/terms-and-conditions">Terms & Conditions</Link>
                                <Link to="/privacy-policy">Privacy Policy</Link>
                                <Link to="/cookie-policy">Cookie Policy</Link>
                                <Link to="/refund-policy">Refund Policy</Link>
                                <Link to="/shipping-policy">Shipping Policy</Link>
                            </li>
                            <li>
                                <h6>Contact Info</h6>

                                <div className="d-flex align-items-start ">
                                    <FaMapMarkerAlt className="me-3 text-dark mt-1" />
                    
                                    <div>
                                        <p className="mb-0 text-dark">
                                        11th Floor, unit 1105, Godrej Genesis Building,  <br />
                                        EP Block, Sector V, Bidhannagar,<br />
                                        Kolkata, West Bengal 700091
                                        </p>
                                    </div>
                                </div>
                
                                <div className="d-flex align-items-start ">
                                    <FaPhoneAlt className="me-3 text-dark mt-2 small" />
                    
                                    <div>
                                        <a
                                        href="tel:+9836610337"
                                        className="mb-0 text-dark text-decoration-none"
                                        >
                                        +91 9836610337
                                        </a>
                                    </div>
                                </div>
                
                                <div className="d-flex align-items-start ">
                                    <FaWhatsapp className="me-3 text-success mt-2" />
                    
                                    <div>
                                        <a
                                        href={`https://wa.me/919836610337?text=${encodeURIComponent(
                                            `Hi, I'm interested in your services. Please share pricing & details.
                                            Thank you!`
                                        )}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-decoration-none text-dark"
                                        >
                                        +91 9836610337
                                        </a>
                                    </div>
                                </div>
                
                                <div className="d-flex align-items-start">
                                <FaEnvelope className="me-3 text-dark mt-2 small" />
                
                                    <div>
                                        <a
                                        href="mailto:contact@grapheweddings.com"
                                        className="mb-0 text-dark text-decoration-none"
                                        >
                                        contact@grapheweddings.com
                                        </a>
                                    </div>
                                </div>
                                
                                <h6 className="mt-4">Follow Us</h6>
                                <div className="d-flex gap-3 socialicon">
                                    <Link to="https://www.facebook.com/grapheweddings" target="_blank" rel="noopener noreferrer"><FaFacebookF /></Link>
                                    <Link to="https://www.instagram.com/grapheweddings/" target="_blank" rel="noopener noreferrer"><GrInstagram /></Link>
                                    <Link to="https://www.youtube.com/channel/UCrupfKu67XWzBHB-i9oiquQ" target="_blank" rel="noopener noreferrer"><FaYoutube /></Link>
                                </div>
                            </li>
                        </ul>
                    </Col>
                </Row>
                <Row className='mx-0 mt-3 pt-3' style={{borderTop: "1px solid #d8c5b4"}}>
                    <Col lg={6} className="mb-3 mb-lg-0 p-0 text-center text-lg-start">
                        <img src={card} alt="Wedding Stationery" className='m-auto m-lg-0' style={{width: "60%"}} />
                    </Col>
                    <Col lg={6} className="mb-0 mb-lg-0 text-center text-lg-end p-0">
                        <small className="small">Copyright &copy; {new Date().getFullYear()} Wedding Stationery. Designed by 
                        <Link to="https://www.thegraphe.com/services/" className="text-secondary">The Graphe - A Design Studio</Link>
                        </small>
                    </Col>
                </Row>
            </Container>
        </footer>
    </>
  )
}

export default Footer
